(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxtg-collection-filters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initForm(form) {
      if (form.dataset.nxtgCf) return;
      form.dataset.nxtgCf = '1';

      // Auto-submit on checkbox / sort change
      form.querySelectorAll('[data-autosubmit]').forEach(function (el) {
        el.addEventListener('change', function () { form.submit(); });
      });
      // Reflect pill active state immediately for feedback
      form.querySelectorAll('.nxtg-cf__pill input').forEach(function (input) {
        input.addEventListener('change', function () {
          input.closest('.nxtg-cf__pill').classList.toggle('is-active', input.checked);
        });
      });

      // Dual-handle price sliders
      form.querySelectorAll('[data-range]').forEach(function (range) {
        var max = parseFloat(range.getAttribute('data-max')) || 100;
        var minInput = range.querySelector('[data-thumb="min"]');
        var maxInput = range.querySelector('[data-thumb="max"]');
        var fill = range.querySelector('[data-fill]');
        var fromLabel = range.querySelector('[data-from]');
        var toLabel = range.querySelector('[data-to]');
        var hiddenMin = range.querySelector('[data-input="min"]');
        var hiddenMax = range.querySelector('[data-input="max"]');
        var step = Math.max(1, Math.round(max / 100));
        minInput.step = step; maxInput.step = step;

        function fmt(n) { try { return Math.round(n).toLocaleString(); } catch (e) { return Math.round(n); } }
        function paint() {
          var lo = parseFloat(minInput.value), hi = parseFloat(maxInput.value);
          if (lo > hi - step) { if (document.activeElement === minInput) { lo = hi - step; minInput.value = lo; } else { hi = lo + step; maxInput.value = hi; } }
          var l = (lo / max) * 100, r = (hi / max) * 100;
          fill.style.left = l + '%';
          fill.style.width = (r - l) + '%';
          if (fromLabel) fromLabel.textContent = fmt(lo);
          if (toLabel) toLabel.textContent = fmt(hi);
        }
        function commit() {
          var lo = Math.round(parseFloat(minInput.value)), hi = Math.round(parseFloat(maxInput.value));
          hiddenMin.value = lo > 0 ? lo : '';
          hiddenMax.value = hi < max ? hi : '';
          form.submit();
        }
        minInput.addEventListener('input', paint);
        maxInput.addEventListener('input', paint);
        minInput.addEventListener('change', commit);
        maxInput.addEventListener('change', commit);
        paint();
      });
    }
    function initAll(scope) { (scope || document).querySelectorAll('.nxtg-cf__form').forEach(initForm); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { initAll(); }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nxtg-feature-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.fsInit) return;
      root.dataset.fsInit = '1';
      var track = root.querySelector('.nxtg-fscroll__track');
      var sticky = root.querySelector('.nxtg-fscroll__sticky');
      var panels = root.querySelectorAll('.nxtg-fscroll__panel');
      var dots = root.querySelectorAll('.nxtg-fscroll__dot');
      var count = panels.length;
      if (!track || !sticky || count === 0) return;
      var cur = -1, running = false, rafId = 0;
      var mq = window.matchMedia('(max-width: 749px)');

      function setActive(i) {
        if (i === cur) return;
        cur = i;
        for (var k = 0; k < panels.length; k++) panels[k].classList.toggle('is-active', k === i);
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      }
      function clearPin() {
        sticky.style.position = ''; sticky.style.top = ''; sticky.style.bottom = '';
        sticky.style.left = ''; sticky.style.width = '';
      }
      // Manual pin -- works regardless of overflow ancestors OR which element scrolls.
      function measure() {
        if (mq.matches) { clearPin(); setActive(0); return; }
        var vh = window.innerHeight;
        var r = track.getBoundingClientRect();
        var total = Math.max(track.offsetHeight - vh, 0);
        var scrolled = Math.min(Math.max(-r.top, 0), total);
        // Absolute-follow pin: the sticky element stays position:absolute inside
        // the relative track, and we move its `top` to track the scroll so it
        // appears pinned. This survives transformed/overflow ancestors that break
        // both position:fixed and position:sticky.
        sticky.style.position = 'absolute';
        sticky.style.left = '0';
        sticky.style.right = 'auto';
        sticky.style.bottom = 'auto';
        sticky.style.width = '100%';
        sticky.style.top = scrolled + 'px';
        if (total <= 0) { setActive(0); return; }
        setActive(Math.min(count - 1, Math.floor((scrolled / total) * count)));
      }
      // rAF loop while the section is on screen: no dependence on scroll events.
      function loop() {
        if (!document.body.contains(root)) { running = false; return; }
        measure();
        if (running) rafId = requestAnimationFrame(loop);
      }
      function start() { if (!running) { running = true; rafId = requestAnimationFrame(loop); } }
      function stop() { running = false; if (rafId) cancelAnimationFrame(rafId); measure(); }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) start(); else stop();
          }
        }, { rootMargin: '300px 0px' });
        io.observe(track);
      } else {
        window.addEventListener('scroll', measure, { passive: true });
        window.addEventListener('resize', measure);
      }

      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            var vh = window.innerHeight;
            var total = track.offsetHeight - vh;
            var p = (+dot.getAttribute('data-index') + 0.5) / count;
            var y = (window.pageYOffset || document.documentElement.scrollTop) + track.getBoundingClientRect().top + p * total;
            window.scrollTo({ top: y, behavior: 'smooth' });
          });
        })(dots[d]);
      }
      measure();
    }
    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('.nxtg-fscroll');
      for (var i = 0; i < nodes.length; i++) initRoot(nodes[i]);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    // Self-heal: the theme editor re-renders sections in place (e.g. after
    // saving a new image) without a full reload. Catch (re)inserted sections
    // and initialize them, no reload required.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (!n || n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('nxtg-fscroll')) initRoot(n);
            else if (n.querySelectorAll) {
              var found = n.querySelectorAll('.nxtg-fscroll');
              for (var k = 0; k < found.length; k++) initRoot(found[k]);
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
